import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagVisibleFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagVisible'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagVisible'
          label='Visible Select'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagVisibleFormGroup)
